"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpoint = exports.Endpoint = exports.getPortalToken = exports.getCurrentToken = void 0;
const querystring_1 = require("querystring");
const ramda_1 = require("ramda");
function getCurrentToken() {
    if (typeof localStorage === 'undefined')
        return '';
    return localStorage.getItem('token') || '';
}
exports.getCurrentToken = getCurrentToken;
function getPortalToken() {
    if (typeof localStorage === 'undefined')
        return '';
    return localStorage.getItem('portalToken') || '';
}
exports.getPortalToken = getPortalToken;
class Endpoint {
    constructor(options) {
        this.method = options.method;
        this.path = options.path;
        this.permissions = options.permissions;
        this.formData = options.formData;
        this.tokens = options.tokens;
        this.query = options.query;
    }
    get tokenString() {
        if (!this.tokens)
            return '';
        const tokens = Object.entries(this.tokens).reduce((result, [key, value]) => `:${key}`, {});
        return `/${tokens}`;
    }
    async apiCall(options, body) {
        let requestBody;
        const token = getCurrentToken ? getCurrentToken() : '';
        const portalToken = getPortalToken ? getPortalToken() : '';
        if (this.formData) {
            requestBody = body;
        }
        else if (this.method !== 'get') {
            requestBody = typeof body === 'string' ? body : JSON.stringify(body);
        }
        let parameters = '';
        let queryString = '';
        if (options) {
            if ('params' in options) {
                parameters = `/${ramda_1.values(options.params || {}).join('/')}`;
            }
            if ('query' in options) {
                queryString = `?${querystring_1.stringify(options.query)}`;
            }
        }
        const headerConfig = {
            Accept: 'application/json',
            Authorization: `${token}`,
            Portal: `${portalToken}`
        };
        if (!this.formData) {
            headerConfig['Content-Type'] = 'application/json';
        }
        const response = await fetch(`/rest/${this.path}${parameters}${queryString}`, {
            // FIXME: Wonder how to get this working without `any`
            body: requestBody,
            headers: new Headers(headerConfig),
            method: this.method,
        });
        return (await response.json());
    }
}
exports.Endpoint = Endpoint;
exports.createEndpoint = () => (options) => new Endpoint(options);



//////////////////
// WEBPACK FOOTER
// ./src/api/endpoint.ts
// module id = 45
// module chunks = 0 1 2